"use-strict";

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.getHeightAddToCart();
    const btn_minimal = this.querySelector("minimal-button");
    if (btn_minimal) {
      btn_minimal.addEventListener("click", this.toggle.bind(this), false);
    }
  }
  getHeightAddToCart() {
    const _this = this;
    this.main = this.closest(".sec__featured-product");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".button-trigger__sticky");
    const footer = document.querySelector(".product-sticky-hide");

    if (!primaryBtn) return;

    var isVisible = true;
    window.addEventListener("scroll", function () {
      var buttonRect = primaryBtn.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 100) {
          _this.classList.remove("show-sticky-cart");
          isVisible = true;
        } else {
          if (
            !isVisible &&
            buttonRect.top < viewportHeight &&
            buttonRect.bottom > 0
          ) {
            isVisible = true;
            _this.classList.remove("show-sticky-cart");
          } else if (isVisible && buttonRect.bottom <= 0) {
            isVisible = false;
            _this.classList.add("show-sticky-cart");
          }
        }
      } else {
        if (
          !isVisible &&
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0
        ) {
          isVisible = true;
          _this.classList.remove("show-sticky-cart");
        } else if (isVisible && buttonRect.bottom <= 0) {
          isVisible = false;
          _this.classList.add("show-sticky-cart");
        }
      }
    });
  }
  toggle(e) {
    const target = e.currentTarget;
    target.classList.toggle("opened");
    if (!target) return;
    const parent = target.closest("sticky-add-cart");
    if (!parent) return;
    const content = parent.querySelector(".content--expand");
    slideAnime({
      target: content,
      animeType: "slideToggle",
    });
  }
}
customElements.define("sticky-add-cart", StickyAddCart);
// js for fake sold
class SoldProduct extends HTMLElement {
  constructor() {
    super();
    this.sold = this.dataset.sold;
    this.hours = this.dataset.hours;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.sold && this.hours) {
      var message = "";
      message = this.message
        .replace("{{ sold }}", this.randomSelect(this.sold))
        .replace("{{ hours }}", this.randomSelect(this.hours));
      this.innerHTML += message;
    }
  }

  randomSelect(numbers) {
    const numberArray = numbers.split(",");
    const randomIndex = Math.floor(Math.random() * numberArray.length);
    const randomNumber = numberArray[randomIndex];
    return randomNumber;
  }
}
customElements.define("sold-product", SoldProduct);

// js for live view
class LiveView extends HTMLElement {
  constructor() {
    super();
    this.min = this.dataset.min;
    this.max = this.dataset.max;
    this.interval = this.dataset.interval;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.max && this.min && this.interval) {
      this.handle();
      setInterval(() => {
        this.handle();
      }, this.interval * 1000);
    }
  }

  handle() {
    var message = "";
    message = this.message.replace(
      "[count]",
      this.randomSelect(parseInt(this.min), parseInt(this.max))
    );
    this.innerHTML = message;
  }

  randomSelect(min, max) {
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomNumber;
  }
}
customElements.define("live-view", LiveView);



class CompareRadios extends SwatchInit {
  constructor() {
    super();
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.init();
    this.initFunction();
  }

  initFunction() {
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      btn.addEventListener("click", this.onVariantChange.bind(this), false);
    });
  }

  onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    target.classList.toggle("active");
    this.handleWhenSwatchUpdate();
  }

  handleWhenSwatchUpdate() {
    this.updateOptions();
    const arrayItem = this.updateMasterId(this.variantData);
    this.handleMediaCompare(arrayItem);
  }

  handleMediaCompare(arrayItem) {
    if (!arrayItem) return;
    const html = `
            ${arrayItem
              .map((item) => {
                return `
                <div class="compare__items-inner">
                        <img width="300px" height="300px" src="${item.featured_media.preview_image.src}" alt="${item.featured_media.alt}">
                        <p class="mb-0 mt-10 heading-style capitalize">${item.title}</p></div>
                    `;
              })
              .join("")}
        `;
    const compareColorContent = this.closest(".compare-colors__content");
    if (!compareColorContent) return;
    const compareItems = compareColorContent.querySelector(".compare__items");
    if (!compareItems) return;
    compareItems.innerHTML = html;
  }

  updateMasterId(variantData) {
    let arrayItem = [];
    this.options.forEach((option) => {
      const matchingVariant = variantData.find((variant) => {
        return variant.options.includes(option);
      });
      if (matchingVariant) {
        arrayItem.push(matchingVariant);
      }
    });
    return arrayItem;
  }
}
customElements.define("compare-radios", CompareRadios);

class ProductRecommendations extends SlideSection {
  constructor() {
    super();
  }
  init() {
    this.call();
  }
  call() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (recommendations.innerHTML.trim().length === 0) {
            // this.remove();
            this.style.display = "none";
            if (document.querySelector(".product-recommendations-heading")) {
              document
                .querySelector(".product-recommendations-heading")
                .remove();
            }
          }
        })
        .finally(() => {
          if (this.querySelector(".swiper-wrapper")) {
            this.initSlide();
            BlsAnimations.innit();
            BlsLazyloadImg.init();          
          }
          initLazyloadItem();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

// js for live view
class SkeletonPage extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    window.setTimeout(() => {
      this.classList.remove("skeleton");
    }, 1500);
  }
}
customElements.define("skeleton-page", SkeletonPage);

// js for live view
class ProductGrouped extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    var group = this.querySelector('.productGroup[type="application/json"]');
    if (!group) return;
    var variantData = JSON.parse(group.innerText);
    var query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    var productAjaxURL = "?q=id:" + query + "&section_id=product-grouped";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.innerHTML = html.querySelector(".product-group").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductGroupAction();
      });
  }

  eventProductGroupAction() {
    document
      .querySelectorAll(".product-group-list .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              compare_price =
                target.options[target.selectedIndex].getAttribute(
                  "data-compare-price"
                );
            var img = target
              .closest(".product-group-list")
              .querySelector(".product-group-item ." + pro_handle + "")
              .querySelector("img");
            if (img) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(".product-group-item");
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                if (compare_price && compare_price > price) {
                  const compare_format = Shopify.formatMoney(
                    compare_price,
                    themeGlobalVariables.settings.money_format
                  );
                  cpp.innerHTML = compare_format;
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price.querySelector(
                      ".price-regular .price"
                    ).innerHTML = Shopify.formatMoney(
                      price,
                      cartStrings.money_format
                    );
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                }
              }
            }
            target.setAttribute("data-price", price);
            target.setAttribute("data-compare-price", compare_price);
          },
          false
        );
      });

    let totalQty = 0;
    const classQty = document.querySelectorAll(
      ".quantity__input-product-group"
    );
    classQty.forEach((input) => {
      let valueQtyDefault = input.value;
      let valueAsDefault = parseFloat(valueQtyDefault);
      if (!isNaN(valueAsDefault)) {
        totalQty += valueAsDefault;
      }
      input.addEventListener("change", () => {
        totalQty = 0;
        classQty.forEach((value) => {
          let valueQty = value.value;
          let valueAsQty = parseFloat(valueQty);
          if (!isNaN(valueAsQty)) {
            totalQty += valueAsQty;
          }
        });
      });
    });
    document.querySelectorAll(".product-group-submit").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitProductGroup(event);
          }
        },
        false
      );
    });

    document.querySelectorAll(".product-group-buy-now").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitNowProductGroup(event);
          }
        },
        false
      );
    });
  }

  submitNowProductGroup(event) {
    event.preventDefault();
    const form = document.getElementById("form-product-grouped");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    config.body = formData;
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.items) {
          window.location.href = "/checkout";
        } else {
          const content = document.querySelector(".form-infor .add-cart-error");
          if (!content) return;
        }
      })
      .catch((e) => {
        throw e;
      });
  }

  submitProductGroup(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("form-product-grouped");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    let openMiniCart = 0;
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        if (parsedState.message) {
          handleErrorMessagePopup(parsedState.description);
          if (!content) return;
        } else {
          parsedState.items.forEach((e) => {
            if (e.quantity > 0) {
              openMiniCart = 1;
            }
          });
          cart.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            const html = new DOMParser().parseFromString(
              parsedState.sections[section.id],
              "text/html"
            );
            elementToReplace.innerHTML =
              html.querySelector("#minicart-form").innerHTML;
            const countdown = cart.querySelector(".cart-countdown-time");
            const html_countdown = html.querySelector(".cart-countdown-time");
            if (countdown && html_countdown) {
              countdown.innerHTML = html_countdown.innerHTML;
            }
          });
          cart.cartAction();
        }
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        if (openMiniCart === 1) {
          cart.open();
        }
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }
}
customElements.define("product-group", ProductGrouped);

// js for product addons
class ProductAddons extends PopupBase {
  constructor() {
    super();
    this.productPopupDiv = this.querySelector(".product-addons__content");
    this.init();
  }
  init() {
    if (this.productPopupDiv) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    const html = this.productPopupDiv;
    if (!html) return;
    html.classList.remove("hidden");
    this.initPopup(
      html,
      `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
    );
  }
}
customElements.define("product-addons", ProductAddons);

class SwatchDropdown extends HTMLElement {
  constructor() {
    super();
    this.spanFor = this.dataset.spanFor;
    this.init();
  }
  init() {
    if (!this.spanFor) return;
    this.addEventListener("click", this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.querySelector(`#${this.spanFor}`).classList.contains("active")) {
      this.querySelector(`#${this.spanFor}`).classList.remove("active");
    } else {
      this.querySelector(`#${this.spanFor}`).classList.add("active");
    }
  }
}
customElements.define("swatch-dropdown", SwatchDropdown);

class ProductBoughtTogether extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const boughTogether = document.querySelector(
      '.productBoughTogether[type="application/json"]'
    );
    if (!boughTogether) return;
    const variantData = JSON.parse(boughTogether.innerText);
    let query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    const productAjaxURL =
      "?q=id:" + query + "&section_id=product-bough-together";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        document.getElementById("product-bought-together").innerHTML =
          html.querySelector(".bought-together").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductBoughTogetherAction();
      });
  }
  eventProductBoughTogetherAction() {
    var _this = this;
    document
      .querySelectorAll(".bought-together-checkbox")
      .forEach((checkbox) => {
        checkbox.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var total_price = 0,
              total_compare_price = 0,
              save_price = 0,
              price,
              compare_price,
              pro_handle = event.target.getAttribute("data-handle");
            var img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "");
            if (target.checked) {
              img.classList.add("select");
              target
                .closest(".product-bought-together-item")
                .classList.add("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .removeAttribute("disabled");
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .removeAttribute("disabled");
            } else {
              img.classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .setAttribute("disabled", true);
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .setAttribute("disabled", true);
            }
            setTimeout(function () {
              var bought_together_select = document.querySelectorAll(
                ".product-bought-together-item.select"
              );
              bought_together_select.forEach((item) => {
                var option = item.querySelector(".product-variant-option");
                price = option.getAttribute("data-price");
                compare_price = option.getAttribute("data-compare-price");
                total_price = total_price + Number(price);
                total_compare_price =
                  total_compare_price + Number(compare_price);
              });
              save_price = total_compare_price - total_price;
              _this.eventProductBoughTogetherUpdatePrice(
                total_price,
                total_compare_price,
                save_price
              );
              if (bought_together_select.length <= 1) {
                document
                  .querySelector(".bought-together-submit")
                  .setAttribute("disabled", true);
              } else {
                document
                  .querySelector(".bought-together-submit")
                  .removeAttribute("disabled");
              }
            }, 50);
          },
          false
        );
      });
    document
      .querySelectorAll("#product-bought-together .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var total_price = 0,
              total_compare_price = 0,
              save_price = 0,
              image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              compare_price =
                target.options[target.selectedIndex].getAttribute(
                  "data-compare-price"
                );
            var img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "")
              .querySelector("img");
            if (img) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(
              ".product-bought-together-item"
            );
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                if (compare_price && compare_price > price) {
                  const compare_format = Shopify.formatMoney(
                    compare_price,
                    themeGlobalVariables.settings.money_format
                  );
                  cpp.innerHTML = compare_format;
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price.querySelector(
                      ".price-regular .price"
                    ).innerHTML = Shopify.formatMoney(
                      price,
                      cartStrings.money_format
                    );
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                }
              }
            }
            target.setAttribute("data-price", price);
            target.setAttribute("data-compare-price", compare_price);
            document
              .querySelectorAll(".product-bought-together-item.select")
              .forEach((item) => {
                var option = item.querySelector(".product-variant-option");
                price = option.getAttribute("data-price");
                compare_price = option.getAttribute("data-compare-price");
                total_price = total_price + Number(price);
                total_compare_price =
                  total_compare_price + Number(compare_price);
              });
            save_price = total_compare_price - total_price;
            _this.eventProductBoughTogetherUpdatePrice(
              total_price,
              total_compare_price,
              save_price
            );
          },
          false
        );
      });

    document.querySelectorAll(".bought-together-submit").forEach((button) => {
      button.addEventListener(
        "click",
        this.submitBoughtTogether.bind(this),
        false
      );
    });
  }
  submitBoughtTogether(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("bought-together-form");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        cart.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);
          const html = new DOMParser().parseFromString(
            parsedState.sections[section.id],
            "text/html"
          );
          elementToReplace.innerHTML =
            html.querySelector("#minicart-form").innerHTML;
          const countdown = cart.querySelector(".cart-countdown-time");
          const html_countdown = html.querySelector(".cart-countdown-time");
          if (countdown && html_countdown) {
            countdown.innerHTML = html_countdown.innerHTML;
          }
        });
        cart.cartAction();
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        cart.open();
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }

  eventProductBoughTogetherUpdatePrice(
    total_price,
    total_compare_price,
    save_price
  ) {
    var total = document.querySelector("#product-bought-together .box-total");
    if (total) {
      total.querySelector(".saved-price .price").innerHTML =
        Shopify.formatMoney(save_price, cartStrings.money_format);
      total.querySelector(".total-price .price__sale .price-item").innerHTML =
        Shopify.formatMoney(total_compare_price, cartStrings.money_format);
      total.querySelector(".total-price .price").innerHTML =
        Shopify.formatMoney(total_price, cartStrings.money_format);
      if (total_compare_price > total_price) {
        total.querySelector(".total-price").classList.add("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.add("special-price");
      } else {
        total.querySelector(".total-price").classList.remove("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.remove("special-price");
      }
      if (save_price > 1) {
        total.querySelector(".saved-price").classList.remove("hidden");
      } else {
        total.querySelector(".saved-price").classList.add("hidden");
      }
    }
  }
}
customElements.define("product-bought-together", ProductBoughtTogether);

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];

    var currentProductID = productJson.id.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "glozin__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "glozin__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    var productJson = JSON.parse(prodData.innerHTML);
    var storedProducts = JSON.parse(
      localStorage.getItem("glozin__recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});
var BlsDropDownProduct = (function () {
  return {
    innit: function () {
      var custom_select = document.querySelectorAll(".custom-select");
      if (custom_select) {
        custom_select.forEach((item) => {
          let select__selected = item.querySelector(".select__selected");
          select__selected.addEventListener("click", (e) => {
            let dropdown = e.target.nextElementSibling;
            dropdown.classList.toggle("hidden");
          });
        });
      }
      document.addEventListener("click", function (event) {
        if (!event.target.closest(".custom-select")) {
          document.querySelectorAll(".select__dropdown")?.forEach((item) => {
            item.classList.add("hidden");
          });
        }
      });
    },
  };
})();

BlsDropDownProduct.innit();

var SyncQuantityInput = (() => {
  return {
    init: () => {
      const syncInputs = document.querySelectorAll(
        ".product-detail__buy-buttons input.quantity-input"
      );
      syncInputs.forEach((input) => {
        input.addEventListener("change", function () {
          const value = this.value;
          syncInputs.forEach((otherInput) => {
            if (otherInput !== input) {
              otherInput.value = value;
            }
          });
        });
      });
    },
  };
})();

SyncQuantityInput.init();

class SlideSectionProductSet extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: document.querySelector(".swiper-pagination-product-set"),
        type: "custom",
        renderCustom: function (swiper, current, total) {
          return current + "/" + total;
        }
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
        },
      },

      on: {
        init: function () {
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
        }
      },
    });
  }
}
customElements.define("slide-section-product-set", SlideSectionProductSet);

/* ==========================================================
   TAPRO V13 - COMPLETE BUNDLE SELECTOR
   Performance optimized - No MutationObserver
   Desktop: 4 columns | Mobile: 2 compact columns
   ========================================================== */
(() => {
  "use strict";

  const STYLE_ID = "tapro-v13-style";
  const PACKS = {
    1: ["1 Stand", "One counter"],
    3: ["3 Stands", "Multiple counters"],
    5: ["5 Stands", "Busy locations"],
    10: ["10 Stands", "Multiple locations"]
  };
  const COUNTS = [1, 3, 5, 10];

  let product = null;
  let productPromise = null;

  /* =========================
     COMPLETE CSS
     ========================= */

  const CSS = `
    fieldset.tapro-v13 {
      display:grid!important;
      grid-template-columns:repeat(4,minmax(0,1fr))!important;
      gap:9px!important;
      align-items:stretch!important;
      margin:8px 0 18px!important;
      padding:0!important;
      min-width:0!important;
    }

    .tapro-v13 > .form__label {
      grid-column:1/-1!important;
      width:100%!important;
      margin:0 0 5px!important;
    }

    .tapro-v13-heading-color {
      display:inline-flex;
      align-items:center;
      gap:6px;
      margin-left:10px;
      font-size:12px;
      font-weight:600;
      color:#506574;
    }

    .tapro-v13-dot {
      display:inline-block;
      flex-shrink:0;
      width:11px;
      height:11px;
      border-radius:50%;
      background:var(--tapro-color,#bbb);
      border:1px solid rgba(0,0,0,.22);
      box-shadow:0 0 0 1px #fff;
    }

    .tapro-v13 > input[type="radio"] {
      position:absolute!important;
      width:1px!important;
      height:1px!important;
      opacity:0!important;
    }

    .tapro-v13 > label.tapro-v13-card {
      position:relative!important;
      display:flex!important;
      flex-direction:column!important;
      align-items:center!important;
      justify-content:flex-start!important;
      width:100%!important;
      min-width:0!important;
      min-height:205px!important;
      margin:0!important;
      padding:25px 5px 12px!important;
      border:1px solid #dbe7ed!important;
      border-radius:14px!important;
      background:linear-gradient(145deg,#fff,#f5fafc)!important;
      color:#243d4d!important;
      text-align:center!important;
      white-space:normal!important;
      cursor:pointer!important;
      overflow:hidden!important;
      box-shadow:0 3px 11px rgba(25,80,105,.06)!important;
      transition:border-color .2s,box-shadow .2s!important;
    }

    .tapro-v13 > label.tapro-v13-card::before,
    .tapro-v13 > label.tapro-v13-card::after {
      content:none!important;
      display:none!important;
    }

    .tapro-v13-original {
      display:none!important;
    }

    .tapro-v13-badge {
      position:absolute;
      z-index:3;
      top:5px;
      left:50%;
      transform:translateX(-50%);
      padding:4px 8px;
      border-radius:20px;
      background:#e0f8ee;
      color:#087f66;
      font-size:9px;
      font-weight:800;
      white-space:nowrap;
    }

    .tapro-v13-badge-deal {
      background:#e6f1ff;
      color:#1766aa;
    }

    .tapro-v13-art {
      display:block;
      width:100%;
      height:88px;
      margin:0 auto 4px;
      flex-shrink:0;
      pointer-events:none;
    }

    .tapro-v13-art svg {
      display:block;
      width:100%;
      height:100%;
    }

    .tapro-v13-title {
      display:block;
      font-size:12px;
      font-weight:800;
      line-height:1.3;
    }

    .tapro-v13-desc {
      display:block;
      margin-top:2px;
      font-size:10px;
      color:#778995;
    }

    .tapro-v13-price {
      display:block;
      margin-top:7px;
      font-size:16px;
      line-height:1.2;
      font-weight:850;
      letter-spacing:-.3px;
      color:#173e56;
    }

    .tapro-v13-compare {
      display:block;
      min-height:14px;
      margin-top:3px;
      font-size:11px;
      color:#8a9ba5;
      text-decoration:line-through;
    }

    .tapro-v13-saving {
      display:block;
      min-height:14px;
      margin-top:2px;
      font-size:10px;
      font-weight:750;
      color:#0a906e;
    }

    .tapro-v13-color {
      display:inline-flex;
      align-items:center;
      justify-content:center;
      gap:5px;
      margin-top:7px;
      font-size:10px;
      font-weight:650;
      color:#506574;
    }

    .tapro-v13 > input[type="radio"]:checked
    + label.tapro-v13-card {
      border:2px solid #229fc9!important;
      background:linear-gradient(145deg,#f2fcff,#e3f6fc)!important;
      box-shadow:0 4px 15px rgba(34,159,201,.17)!important;
    }

    .tapro-v13 > input[type="radio"]:checked
    + label.tapro-v13-card .tapro-v13-title::after {
      content:" ✓";
      color:#169bc4;
    }

    .tapro-v13 > input[type="radio"]:focus-visible
    + label.tapro-v13-card {
      outline:3px solid #229fc9!important;
      outline-offset:2px;
    }

    .tapro-v13-note {
      grid-column:1/-1;
      margin:3px 0 0;
      font-size:11px;
      line-height:1.4;
      color:#758893;
    }

    @media(hover:hover) {
      .tapro-v13 > label.tapro-v13-card:hover {
        border-color:#45b5d0!important;
        box-shadow:0 5px 16px rgba(34,159,201,.12)!important;
      }
    }

    /* COMPACT MOBILE */
    @media(max-width:749px) {
      fieldset.tapro-v13 {
        grid-template-columns:repeat(2,minmax(0,1fr))!important;
        gap:7px!important;
        margin:5px 0 10px!important;
      }

      .tapro-v13-heading-color {
        display:flex;
        width:max-content;
        margin:5px 0 0;
      }

      .tapro-v13 > label.tapro-v13-card {
        min-height:150px!important;
        padding:21px 5px 7px!important;
        border-radius:11px!important;
      }

      .tapro-v13-art {
        height:57px!important;
        margin:0 auto 2px!important;
      }

      .tapro-v13-title {
        font-size:11px!important;
        line-height:1.15!important;
      }

      .tapro-v13-desc {
        display:none!important;
      }

      .tapro-v13-price {
        font-size:14px!important;
        margin-top:4px!important;
        line-height:1.15!important;
      }

      .tapro-v13-compare,
      .tapro-v13-saving {
        font-size:10px!important;
        min-height:0!important;
        margin-top:2px!important;
      }

      .tapro-v13-color {
        font-size:9px!important;
        margin-top:4px!important;
      }

      .tapro-v13-dot {
        width:9px!important;
        height:9px!important;
      }

      .tapro-v13-badge {
        font-size:8px!important;
        padding:3px 6px!important;
        top:4px!important;
      }

      .tapro-v13-note {
        font-size:10px!important;
        margin-top:0!important;
        line-height:1.3!important;
      }
    }
  `;

  /* =========================
     UTILITIES
     ========================= */

  function el(tag, className = "", value) {
    const node = document.createElement(tag);
    node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  }

  function setText(node, value) {
    if (node && node.textContent !== value) {
      node.textContent = value;
    }
  }

  function installCSS() {
    if (document.getElementById(STYLE_ID)) return;

    const style = el("style");
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  /* =========================
     CLEAR ACRYLIC ARTWORK
     ========================= */

  function stand(x, y, scale, rotation, id) {
    return `
      <g transform="translate(${x} ${y})
        scale(${scale}) rotate(${rotation})">

        <ellipse cx="1" cy="2" rx="24" ry="4.5"
          fill="#658da3" opacity=".17"/>

        <path d="M5 -53 L17 -5 L11 -5 L1 -51 Z"
          fill="#a5d2e5" fill-opacity=".24"
          stroke="#9bbfd0" stroke-width=".75"/>

        <path d="M-18 -5 L15 -5 L25 0 L-26 0 Z"
          fill="url(#base-${id})"
          stroke="#9fbfce" stroke-width="1"/>

        <path d="M-26 0 H25 L22 3 H-23 Z"
          fill="#bddbe8" fill-opacity=".65"
          stroke="#9cbfce" stroke-width=".65"/>

        <path d="M-15 -66 Q-15 -70 -11 -70
          H12 Q16 -70 16 -66 V-7 H-15 Z"
          fill="url(#glass-${id})"
          stroke="#8fb8ca" stroke-width="1.45"/>

        <path d="M-15 -66 L-12 -66 V-10 L-15 -7 Z"
          fill="#e9faff" fill-opacity=".78"/>

        <path d="M12 -66 L16 -66 V-7 L12 -10 Z"
          fill="#8dc4dc" fill-opacity=".34"/>

        <path d="M-10 -65 L-4 -65 L-8 -12 L-13 -12 Z"
          fill="#fff" fill-opacity=".48"/>

        <path d="M8 -63 L10 -63 L9 -13 L7 -13 Z"
          fill="#fff" fill-opacity=".55"/>

        <g fill="none" stroke="#89b1c3"
          stroke-width="1.1" stroke-linecap="round"
          opacity=".55">
          <path d="M-4 -42 Q1 -37 -4 -32"/>
          <path d="M1 -45 Q9 -37 1 -29"/>
        </g>

        <g opacity=".32" fill="#7fa9bc">
          <rect x="-5" y="-23" width="3" height="3"/>
          <rect x="2" y="-23" width="3" height="3"/>
          <rect x="-5" y="-17" width="3" height="3"/>
          <rect x="0" y="-19" width="2" height="2"/>
          <rect x="3" y="-16" width="2" height="2"/>
        </g>

        <path d="M-10 -67 H11"
          stroke="#fff" stroke-width="1.5" opacity=".9"/>
      </g>
    `;
  }

  function artwork(count) {
    const positions = {
      1: [[55,84,1.04,0]],
      3: [
        [32,84,.79,-6],
        [55,84,1,0],
        [78,84,.79,6]
      ],
      5: [
        [20,84,.61,-9],
        [38,84,.75,-5],
        [55,84,.96,0],
        [72,84,.75,5],
        [90,84,.61,9]
      ],
      10: [
        [19,49,.47,-8],
        [37,49,.51,-4],
        [55,49,.55,0],
        [73,49,.51,4],
        [91,49,.47,8],
        [19,84,.52,-8],
        [37,84,.57,-4],
        [55,84,.64,0],
        [73,84,.57,4],
        [91,84,.52,8]
      ]
    };

    const id = "tapro-glass-v13-" + count;

    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 110 94"
        preserveAspectRatio="xMidYMid meet">
        <defs>
          <linearGradient id="glass-${id}"
            x1="0" y1="0" x2="1" y2=".25">
            <stop offset="0%" stop-color="#e5f8ff"
              stop-opacity=".83"/>
            <stop offset="28%" stop-color="#fff"
              stop-opacity=".19"/>
            <stop offset="65%" stop-color="#d0effb"
              stop-opacity=".36"/>
            <stop offset="100%" stop-color="#9fcfe3"
              stop-opacity=".59"/>
          </linearGradient>

          <linearGradient id="base-${id}"
            x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#f1fcff"
              stop-opacity=".78"/>
            <stop offset="100%" stop-color="#b6d7e7"
              stop-opacity=".58"/>
          </linearGradient>
        </defs>

        ${positions[count].map(
          p => stand(...p,id)
        ).join("")}
      </svg>
    `;

    const node = el("span","tapro-v13-art");
    node.setAttribute("aria-hidden","true");
    node.innerHTML = svg;
    return node;
  }

  /* =========================
     VARIANT AND COLOR HELPERS
     ========================= */

  function quantity(value) {
    const match = String(value).match(
      /^\s*(1|3|5|10)\s*[- ]?\s*stands?\b/i
    );
    return match ? Number(match[1]) : null;
  }

  function colorOf(fieldset) {
    const picker = fieldset.closest(
      ".product-detail__variant-picker"
    );

    const group = picker && picker.querySelector(
      "fieldset.product-form__input_color"
    );

    const checked = group && group.querySelector(
      'input[type="radio"]:checked'
    );

    const name = checked
      ? checked.value.trim()
      : "Selected";

    const palette = {
      black:"#171717",
      white:"#ffffff",
      pink:"#f2afc5",
      gray:"#9fa7ad",
      grey:"#9fa7ad",
      silver:"#c7cdd2",
      blue:"#4786cd",
      red:"#d94d4d",
      green:"#46a77a",
      purple:"#8d6bb4",
      yellow:"#f1d748",
      gold:"#d6b76a",
      beige:"#e8ddd1",
      orange:"#ef9b50"
    };

    return {
      name,
      hex:palette[name.toLowerCase()] || "#bfc9d0"
    };
  }

  function money(cents) {
    const currency =
      window.Shopify?.currency?.active || "USD";

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || "en-US",
        {style:"currency",currency}
      ).format(cents / 100);
    } catch (error) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function variantFor(colorName,count) {
    if (!product?.variants) return null;

    const color = colorName.trim().toLowerCase();

    return product.variants.find(variant => {
      const options = [
        variant.option1,
        variant.option2,
        variant.option3
      ].filter(value => value != null);

      return (
        options.some(value => quantity(value) === count) &&
        options.some(value =>
          String(value).trim().toLowerCase() === color
        )
      );
    }) || null;
  }

  /* =========================
     REAL SHOPIFY PRICES
     ========================= */

  function renderPricing(fieldset) {
    if (!product) return;

    const color = colorOf(fieldset);
    const variants = {};

    COUNTS.forEach(count => {
      variants[count] = variantFor(color.name,count);
    });

    const unitPrices = COUNTS
      .filter(count => variants[count]?.available)
      .map(count => Number(variants[count].price) / count)
      .filter(Number.isFinite);

    const lowestUnit = unitPrices.length
      ? Math.min(...unitPrices)
      : null;

    COUNTS.forEach(count => {
      const card = fieldset.querySelector(
        'label[data-tapro-count="' + count + '"]'
      );

      if (!card) return;

      const priceNode = card.querySelector(
        ".tapro-v13-price"
      );
      const compareNode = card.querySelector(
        ".tapro-v13-compare"
      );
      const savingNode = card.querySelector(
        ".tapro-v13-saving"
      );
      const badgeNode = card.querySelector(
        ".tapro-v13-badge"
      );

      const variant = variants[count];

      if (!variant) {
        setText(priceNode,"Unavailable");
        setText(compareNode,"");
        setText(savingNode,"");
        return;
      }

      const price = Number(variant.price);

      const compare = variant.compare_at_price == null
        ? null
        : Number(variant.compare_at_price);

      if (!Number.isFinite(price)) {
        setText(priceNode,"Price unavailable");
        setText(compareNode,"");
        setText(savingNode,"");
        return;
      }

      setText(priceNode,money(price));

      if (
        compare !== null &&
        Number.isFinite(compare) &&
        compare > price
      ) {
        setText(compareNode,money(compare));
        setText(
          savingNode,
          "Save " + money(compare - price)
        );
      } else {
        setText(compareNode,"");
        setText(savingNode,"");
      }

      if (count === 10 && badgeNode) {
        const bestDeal =
          variant.available &&
          lowestUnit !== null &&
          Math.abs(price / 10 - lowestUnit) < .001;

        setText(
          badgeNode,
          bestDeal ? "BEST DEAL" : "10-PACK"
        );
      }
    });
  }

  function update(fieldset) {
    const color = colorOf(fieldset);

    if (
      fieldset.style.getPropertyValue("--tapro-color")
      !== color.hex
    ) {
      fieldset.style.setProperty(
        "--tapro-color",
        color.hex
      );
    }

    fieldset.querySelectorAll(
      ".tapro-v13-color-name"
    ).forEach(node => setText(node,color.name));

    setText(
      fieldset.querySelector(".tapro-v13-note"),
      "Clear stands illustrate quantity only. " +
      "Your order will be supplied in your selected color: " +
      color.name + "."
    );

    renderPricing(fieldset);
  }

  /* =========================
     BUILD SELECTOR ONCE
     ========================= */

  function enhance(root = document) {
    const fieldsets = root.querySelectorAll(
      ".product-detail__variant-picker " +
      "fieldset.product-form__input"
    );

    fieldsets.forEach(fieldset => {
      if (fieldset.dataset.taproV13 === "ready") {
        update(fieldset);
        return;
      }

      const radios = Array.from(
        fieldset.querySelectorAll(
          ':scope > input[type="radio"]'
        )
      );

      const matches = radios.map(radio => ({
        radio,
        count:quantity(radio.value)
      })).filter(item => item.count !== null);

      if (
        matches.length !== 4 ||
        new Set(matches.map(item => item.count)).size !== 4
      ) return;

      const labels = matches.map(({radio,count}) => ({
        radio,
        count,
        label:Array.from(
          fieldset.querySelectorAll(":scope > label")
        ).find(label => label.htmlFor === radio.id)
      }));

      // Preserve Glozin's original radio-label structure.
      if (
        labels.some(item =>
          !item.label ||
          item.label.previousElementSibling !== item.radio
        )
      ) return;

      installCSS();

      fieldset.classList.add("tapro-v13");
      fieldset.dataset.taproV13 = "ready";

      const heading = fieldset.querySelector(
        ":scope > .form__label"
      );

      if (
        heading &&
        !heading.querySelector(".tapro-v13-heading-color")
      ) {
        const headingColor = el(
          "span","tapro-v13-heading-color"
        );

        headingColor.append(
          el("span","tapro-v13-dot"),
          el("span","","Your color: "),
          el("span","tapro-v13-color-name")
        );

        heading.appendChild(headingColor);
      }

      labels.forEach(({count,label}) => {
        const original = el(
          "span","tapro-v13-original"
        );

        while (label.firstChild) {
          original.appendChild(label.firstChild);
        }

        label.appendChild(original);

        if (count === 5 || count === 10) {
          label.appendChild(
            el(
              "span",
              "tapro-v13-badge" +
              (count === 10
                ? " tapro-v13-badge-deal"
                : ""),
              count === 5
                ? "MOST POPULAR"
                : "10-PACK"
            )
          );
        }

        label.append(
          artwork(count),
          el("span","tapro-v13-title",PACKS[count][0]),
          el("span","tapro-v13-desc",PACKS[count][1]),
          el("span","tapro-v13-price",""),
          el("span","tapro-v13-compare",""),
          el("span","tapro-v13-saving","")
        );

        const colorLine = el(
          "span","tapro-v13-color"
        );

        colorLine.append(
          el("span","tapro-v13-dot"),
          el("span","tapro-v13-color-name")
        );

        label.appendChild(colorLine);
        label.classList.add("tapro-v13-card");
        label.dataset.taproCount = String(count);
      });

      fieldset.appendChild(
        el("div","tapro-v13-note")
      );

      update(fieldset);
    });

    loadProduct();
  }

  /* =========================
     FETCH PRICES ONLY ONCE
     ========================= */

  function loadProduct() {
    if (productPromise) return productPromise;

    const match = location.pathname.match(
      /\/products\/([^/?#]+)/
    );

    if (!match) return Promise.resolve();

    const root = window.Shopify?.routes?.root || "/";

    const url =
      root.replace(/\/?$/,"/") +
      "products/" +
      encodeURIComponent(decodeURIComponent(match[1])) +
      ".js";

    productPromise = fetch(url,{
      credentials:"same-origin"
    })
    .then(response => {
      if (!response.ok) {
        throw new Error("Product pricing unavailable");
      }
      return response.json();
    })
    .then(data => {
      product = data;

      document.querySelectorAll(
        "fieldset.tapro-v13"
      ).forEach(renderPricing);
    })
    .catch(error => {
      console.warn("TAPro V13:",error);
    });

    return productPromise;
  }

  /* =========================
     LIGHTWEIGHT EVENT HANDLERS
     NO PAGE-WIDE OBSERVER
     ========================= */

  function start() {
    enhance();

    document.addEventListener(
      "shopify:section:load",
      event => enhance(event.target)
    );

    document.addEventListener("change",event => {
      if (
        event.target.matches(
          '.product-form__input_color input[type="radio"]'
        )
      ) {
        const picker = event.target.closest(
          ".product-detail__variant-picker"
        );

        if (picker) {
          picker.querySelectorAll(
            "fieldset.tapro-v13"
          ).forEach(update);
        }
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {once:true}
    );
  } else {
    start();
  }
})();
